module.exports = __webpack_public_path__ + "static/media/Brezi.cb490d43.md";